import React, { PureComponent } from 'react'
import { func, shape, string, bool } from 'prop-types'
import FormField from '@active/react-ui/FormField'
import FormGroup from '@active/react-ui/FormGroup'
import FormLabel from '@active/react-ui/FormLabel'
import Button from '@active/react-ui/Button'
import EmailInput from '@active/react-ui/EmailInput'
import FormError from '@active/react-ui/FormError'
import { withI18n } from '@active/react-utils/i18n'

import Form from '../InjectedForm'
import DefaultComponentLayout, { LayoutContent } from '../Layout'
import I18nMessage from '../I18nMessage'
import CoppaConfirmation from './components/CoppaConfirmation'
import './CoppaEmailInput.scss'

class CoppaEmailInput extends PureComponent {
  static propTypes = {
    i18n: func.isRequired,
    services: shape({
      verification: func.isRequired,
    }).isRequired,
    pendingKey: string.isRequired,
    configureTrack: func.isRequired,
    Header: func,

    authWithKeycloak: bool,
    onKeycloakSubmit: func,
    forceV4: bool,
  }

  static defaultProps = {
    Header: null,

    authWithKeycloak: false,
    onKeycloakSubmit: null,
    forceV4: false,
  }

  constructor(props) {
    super(props)
    this.state = {
      showCoppaConfirmation: false,
      errorMsg: null,
    }
  }

  componentDidMount() {
    const { configureTrack } = this.props
    configureTrack({
      eventName: 'ParentOrGuardianVerification',
      widget: 'create_account',
      pageType: 'COPPA',
    })
  }

  handleKeycloakVerification = ({params, resolve}) => {
    const { onKeycloakSubmit } = this.props
    const data = {
      guardianemail: params.guardianemail,
      pendingKey: params.pendingKey,
      detailAction: 'COPPA_ACTION'
    }
    onKeycloakSubmit(data).then(result => resolve(result))
  }

  handleSubmit = values => {
    const { pendingKey, services, i18n, authWithKeycloak, forceV4 } = this.props
    const data = { ...values, pendingKey }

    let verification = authWithKeycloak ? this.handleKeycloakVerification : services.verification
    if (forceV4) {
      verification = services.verification
    }

    verification({
      params: data,
      resolve: ({ status, message }) => {
        if (status === 'SUCCESS') {
          this.setState({
            showCoppaConfirmation: true,
            guardianemail: values.guardianemail,
          })
        } else {
          const msg = message || i18n('passport.error.server.default')
          this.setState({
            errorMsg: msg,
          })
        }
      },
      reject: () => {
        this.setState({
          errorMsg: i18n('passport.error.server.default'),
        })
      },
    })
  }

  handleChange = () => {
    this.setState({ errorMsg: null })
  }

  render() {
    const { configureTrack, Header } = this.props
    const { showCoppaConfirmation, guardianemail, errorMsg } = this.state

    if (showCoppaConfirmation) {
      return (<CoppaConfirmation Header={Header} guardianemail={guardianemail} configureTrack={configureTrack} />)
    }

    return (
      <DefaultComponentLayout nameSpace="passport__coppaemail" Header={Header}>
        <LayoutContent title message="passport.coppa.notice.create" />
        <LayoutContent subTitle message="passport.coppa.notice.thanksFor" />
        <LayoutContent main>
          <Form onSubmit={this.handleSubmit} onChange={this.handleChange} noValidate>
            <FormGroup name="guardianemail" required withoutLayout>
              <FormError errorMessage={errorMsg} showError={!!errorMsg} theme="inline" />
              <FormLabel><I18nMessage id="passport.coppa.notice.parent" /></FormLabel>
              <FormField
                as={EmailInput}
                requiredError="passport.error.validation.invalidEmail"
                invalidError="passport.error.validation.invalidEmail"
              />
            </FormGroup>
            <Button className="passport__coppaemail__button" type="super" submit>
              <I18nMessage id="passport.coppa.notice.send" />
            </Button>
          </Form>
        </LayoutContent>
      </DefaultComponentLayout>
    )
  }
}

export default withI18n(CoppaEmailInput)
